import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';

import { DynamicFormCalcTableCellComponent } from './dynamic-form-calc-table-cell.component';
import { FilterWithPipe } from '@lockton-apps/shared/ui/pipes';

@NgModule({
  declarations: [DynamicFormCalcTableCellComponent],
  imports: [
    CommonModule,
    MaterialModule,
    UiModule,
    FilterWithPipe,
    DecimalPipe,
  ],
  exports: [DynamicFormCalcTableCellComponent],
})
export class DynamicFormCalcTableCellModule {}
